import { Instagram, Linkedin, Globe, ArrowUpRight } from "lucide-react";
import Logo from "./Logo.jsx";
import { BRAND, NAV_LINKS } from "../theme.js";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-navy-950 text-white">
      <div className="container-x py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo light />
            <p className="mt-5 max-w-md text-sm leading-relaxed text-white/70">
              Wetterdesign är en webbyrå vid Vätterns strand som bygger
              moderna, snabba hemsidor med mänsklig touch och AI i ryggen.
            </p>
            <div className="mt-6 flex items-center gap-2">
              {[
                { icon: Instagram, href: BRAND.social.instagram, label: "Instagram" },
                { icon: Linkedin, href: BRAND.social.linkedin, label: "LinkedIn" },
                { icon: Globe, href: BRAND.social.behance, label: "Behance" },
              ].map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="grid h-10 w-10 place-items-center rounded-full border border-white/15 bg-white/5 text-white/85 transition hover:bg-white/10"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-sand-200">
              Navigera
            </p>
            <ul className="mt-4 space-y-2.5 text-sm text-white/80">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a className="hover:text-white" href={l.href}>
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a className="hover:text-white" href="/admin">
                  Admin
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-sand-200">
              Kontakt
            </p>
            <ul className="mt-4 space-y-2.5 text-sm text-white/80">
              <li>
                <a className="hover:text-white" href={`mailto:${BRAND.email}`}>
                  {BRAND.email}
                </a>
              </li>
              <li>
                <a
                  className="hover:text-white"
                  href={`tel:${BRAND.phone.replace(/\s/g, "")}`}
                >
                  {BRAND.phone}
                </a>
              </li>
              <li>
                {BRAND.city} · {BRAND.region}
              </li>
            </ul>

            <a
              href="#kontakt"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-sand-300 px-5 py-2.5 text-sm font-semibold text-navy-900 transition hover:bg-sand-400"
            >
              Starta projekt
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/80 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} {BRAND.name}. Alla rättigheter förbehållna.</p>
          <div className="flex items-center gap-5">
            <a className="hover:text-white" href="#">Integritetspolicy</a>
            <a className="hover:text-white" href="#">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
